export const igv_ir_m = [
  {
    id: 1,
    title: "IR Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Check the IR Tracker and keep it updated.",
      " To be a communication bridge between the team leaders and the OEVP.",
      " Take part in IR Meetings and be in touch with the IR partners.",
      " Research about new possible IR Partners (Daal analysis).",
      " Brainstorm new creative methods to promote our iGV Projects and events.",
      " Brainstorm new IR events & execute them with IR partners (with the approval from the OEVP).",
      " Take Team Meetings with your team leaders.",
      " Join LBMs & General Meetings of the Function.",
      " Join monthly OEMs (Official Expansion Meeting).",
    ],
    subTitile02: "KPIs",
    KPIs: ["# APP.", "# opens.", "# APD.", "#% APP - APD."],
    color: "#F85A40",
    application: {
      applicationLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSeUVNislnLarUoqpxKUn13d6k99YFeBhLjQqAz1WXMicJwTxQ/viewform",
      teamStructure: [
        "IR Manager x1",
        "Matching Manager x1",
        "Team Leader - IR x3",
        "Team Leader x3",
      ],
      specialInfo: [
        "*All the candidates must have attended a minimum of one OEM or any other AIESEC event during the past three months.",
        "*Candidates, only those who complete the Assessment Center will be called for the interviews.",
      ],
    },
    function: {
      functionName: "iGV IR & M",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Matching Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Check the Matching Tracker and keep it updated.",
      " To be a communication bridge between the team leaders and the OEVP.",
      " Taking responsibility for your Team Leaders.",
      " Take Team Meetings with your team leaders.",
      " Join LBMs & General Meetings of the Function.",
      " Join monthly OEMs (Official Expansion Meeting).",
    ],
    subTitile02: "KPIs",
    KPIs: ["# APP.", "# opens.", "# APD.", "#% APP - APD."],
    color: "#F85A40",
  },
  {
    id: 3,
    title: "Team Leader - IR",
    subTitile01: "Job Description",
    jobDescription: [
      " Make sure a better connection is built between members and IR partners.",
      " Brainstorm new creative methods to promote our iGV Projects and events.",
      " Assign members to reach out new and existing IR partners.",
      " Build up new partnerships and make new WhatsApp groups with them.",
      " Keep the communication running on those WhatsApp groups.",
      " Plan new IR events with members and pitch them to the Manager.",
      " To be a communication bridge between members and the manager.",
      " Taking responsibility for your team.",
      " Check whether the IR Tracker is uptodate.",
      " Schedule IR Meetings at least once every two months.",
      " Take Team Meetings with your team members.",
      " Join LBMs & General Meetings of the Function.",
      " Join monthly OEMs (Official Expansion Meeting)",
    ],
    subTitile02: "KPIs",
    KPIs: ["# APP.", "# opens.", "# APD.", "#% APP - APD."],
    color: "#F85A40",
  },
  {
    id: 4,
    title: "Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Should check EXPA at least twice a day for any Open applications.",
      " Check whether the members have contacted the EPs within 24 hours (48 maximum).",
      " Collect EPs details and share them with the OEVP iGV B2B & VD function.",
      " Take Team Meetings with your team members.",
      " Join LBMs & General Meetings of the Function.",
      " Join monthly OEMs (Official Expansion Meeting)",
    ],
    subTitile02: "KPIs",
    KPIs: ["# APP.", "# APD.", "#% APP - APD."],
    color: "#F85A40",
  },
];

export const igv_b2b_vd = [
  {
    id: 1,
    title: "B2B Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Develop partnerships with organizations in order to get monetary or in-kind support for the iGV projects",
      " Creating and implementing ER/B2B strategies",
      " Responsible for the partnership deliverables",
      " Partnership Management",
      " Reaching out ER/B2B goals set by the OEVP",
      " Understanding and addressing synergy points with other positions and functions as required",
      " Performing additional duties related to the projects set out by the OEVP",
      " Handling the B2B TLs in order to full fill the above goals",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "# of ER partners",
      "# of B2B partners",
      " % of goal reach",
      " % of ER raise out of cost",
      "# of company meetings arrange",
      "0 complaints from partners",
      "Partner NPS",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Strong Communication",
      "Stakeholder management",
      "Time management",
      "Documentationing",
      "Solution-oriented",
      "Past experiences from a PD background",
      "Notable past partnership raisings",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 14 hours per week", "Duration - 6 months"],
    color: "#F85A40",
    application: {
      applicationLink: "https://forms.gle/asK6FU4A67FQzejq6",
      teamStructure: [
        "B2B Manager x1",
        "Marketing Manager x1",
        "Finance Manager x1",
        "Logistics and Events Manager x1",
        "CXP & VD Manager x2",
        "B2B Team Leader x3",
        "CXP & VD Team Leader x5",
      ],
      specialInfo: [
        "*All the candidates must have attended a minimum of one OEM or any other AIESEC event during the past three months.",
        "*Candidates, only those who complete the Assessment Center will be called for the interviews.",
      ],
    },
    function: {
      functionName: "iGV B2B & VD",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Marketing Manager ",
    subTitile01: "Job Description",
    jobDescription: [
      "Planning iGV project marketing timeline",
      "Creating and implementing marketing strategies",
      "Increasing outreach through various platforms",
      "Creating digital marketing materials & tools",
      "Collect and organize project content for showcasing",
      "Content creation and comprehensive writing skills",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "Impact showcased through Digital Platforms",
      "# of marketing flyers",
      "# of marketing videos",
      "# of project booklets",
      "0 Branding complaints",
      "0 content complaints",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Content Management",
      "Strong communication & Networking skills",
      "Creative thinking & Time management",
      "Solution oriented",
      "Past experiences from a MKT background",
      "Knowledge in branding, graphic designing & video editing",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 14 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
  {
    id: 3,
    title: "Finance Manager",
    subTitile01: "Job Description",
    jobDescription: [
      "Manage the ﬁnance of the projects",
      "Cash flow management of the projects",
      "Preparing and reviewing necessary project budgets and reports",
      "Responsible for project budget execution",
      "Implementing cost-cutting strategies",
      "Preparing monthly ﬁnance report",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "% of budget achievement",
      "0 Cash ﬂow issues",
      "% of proﬁtability of the project",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Finance skills",
      "Information & data management skills",
      "Reporting skills",
      "Flexibility & adaptability",
      "Critical thinking",
      "Cost-cutting skills",
      "Past experiences from a Finance background",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 14 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
  {
    id: 4,
    title: "Logistics and Events Manager",
    subTitile01: "Job Description",
    jobDescription: [
      "Identifying logistical requirements",
      "Finding most appropriate ways to fulﬁll logistics requirements",
      "Stakeholder management when necessary",
      "Preparing inventory management and inventory ﬂow management plans",
      "Finding partners to cover logistical requirements together with B2B Manager",
      "Responsible for handling events in iGV projects",
      "Should be able to work physically",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "0 logistics complaints",
      "0 complains about project accommodation, transportation and etc.",
      "# partner aligned/raised to cover logistics requirements",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Solution oriented",
      "Flexibility & adaptability",
      "Strong Communication",
      "Critical thinking",
      "Time management",
      "Past experiences from a Logistics background",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 14 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
  {
    id: 5,
    title: "CXP & VD Manager",
    subTitile01: "Job Description",
    jobDescription: [
      "Responsible for handling the iGV membership",
      "Responsible for handling the iGV projects",
      "Responsible for EP handling",
      "Responsible for the volunteer deliverables",
      "Reviewing project flows",
      "Maintain, track and record project details ",
      "Should be able to work physically",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
      "Handling the CXP & VD TLs in order to full fill the above goals",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "# of Opens",
      "% of FIN - CO",
      "EP NPS",
      "0 complaints from the membership",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Solution oriented",
      "Flexibility & adaptability",
      "Strong Communication",
      "Critical thinking",
      "Time management",
      "Reporting skills",
      "Being a TL or TM in a past iGV project",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 14 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
  {
    id: 6,
    title: "B2B Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      "Develop partnerships with organizations in order to get monetary or in-kind support for the iGV projects",
      "Creating and implementing ER/B2B strategies",
      "Responsible for the partnership deliverables",
      "Partnership Management",
      "Reaching out ER/B2B goals set by the B2B Manager/OEVP",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
    ],
    subTitile02: "KPIs",
    KPIs: [
      "# of ER partners",
      "# of B2B partners",
      "% of goal reach",
      "% of ER raise out of cost",
      "# of company meetings arrange",
      "0 complaints from partners",
      "Partner NPS",
    ],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Strong Communication",
      "Stakeholder management",
      "Time management",
      "Documentationing",
      "Solution-oriented",
      "Past experiences from a PD background",
      "Notable past partnership raisings",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 10 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
  {
    id: 7,
    title: "CXP & VD Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      "Responsible for handling the appointed iGV project",
      "Responsible for EP handling in the specific project",
      "Responsible for the volunteer deliverables",
      "Planning the project flow",
      "Recording project details ",
      "Should be able to work physically",
      "Understanding and addressing synergy points with other positions and functions as required",
      "Performing additional duties related to the projects set out by the OEVP",
    ],
    subTitile02: "KPIs",
    KPIs: ["% of FIN - CO", "EP NPS", "0 complaints from EPs"],
    subTitile03: "Skills & Knowledge",
    skills: [
      "Solution oriented",
      "Flexibility & adaptability",
      "Strong Communication",
      "Critical thinking",
      "Time management",
      "Reporting skills",
      "Being a TM in a past iGV project",
    ],
    subTitile04: "Working Conditions",
    conditions: ["Working hours: 10 hours per week", "Duration - 6 months"],
    color: "#F85A40",
  },
];

export const ogx = [
  {
    id: 1,
    title: "Team Leader - B2C",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for initiation and execution of oGTa and oGTe offline promotions, research and analysis for the markets allocated.",
      " Responsible for managing LEADs and allocating members for LEAD management.",
      " Responsible for managing LEADs and allocating members for LEAD management.",
      " Downscaling the strategies/action plans communicated by the LCVP/OEVP.",
      " Responsible for handling external entities and ensure that sufficient sign-ups are received to follow up.",
      " Responsible for raising B2B partnerships and signing MoUs.",
      " Maintaining real-time trackers as advised by the LCVP/OEVP.",
      " Organizing events for online and offline promotions.",
      " Maintaining member delegation and engagement.",
      " Accountability towards team performance.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of SUs.",
      " # of APP.",
      " # of B2B Partnerships raised.",
      " # of Offline Promotions.",
      " # of Online Campaigns.",
      " # of events.",
      " # of Team meetings held.",
    ],
    color: "#FFC845",
    application: {
      applicationLink:
        "https://docs.google.com/forms/d/e/1FAIpQLScuekQQCWmhYsf7YpbwxUFy5oTt3luZOB91bdKTGSv8N08c0Q/viewform?usp=sf_link",
      teamStructure: ["Team Leaders x14"],
      specialInfo: [
        "The selected LB applicants will be allocated to their specific function which is either of oGX - B2C, oGT - PS, oGV - PS based on their performance at the Interviews.",
      ],
    },
    function: {
      functionName: "oGX",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Team Leader - PS",
    subTitile01: "Job Description",
    jobDescription: [
      " Create IR Partnerships with entities abroad.",
      " Maintain Contact with the IR partners.",
      " Have a good synergy with the oGT B2C team and provide them with the projects.",
      " Provide the Marketing Team with the project content of the Partners.",
      " Downscaling the strategies/action plans communicated by the Managers to your Members.",
      " Maintaining real-time trackers as advised by the Managers.",
      " Maintaining real-time trackers as advised by the LCVP/OEVP.",
      " Maintaining member delegation and engagement.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of ACC (Acceptances).",
      " # of APD (Approvals).",
      " # of RE (Realizations).",
      " # of FIN (Finishes).",
      " # of Co (Completions).",
      " # of IR partnerships raised.",
      " # of Team Meetings held.",
    ],
    color: "#FFC845",
  },
];

export const igt_ir_m = [
  {
    id: 1,
    title: "OxP Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Team management.",
      " Taking responsibility for the Team Leaders.",
      " Manage Knowledge sharing sessions and downscaling the functional knowledge.",
      " Track performance of the the Team Leaders and Team Members.",
      " Updating IR VP about the IR partners and opportunities.",
      " Assist in making midterm to long term strategies with OEVP.",
      " Brainstorm new creative methods to promote iGT IR opportunities.",
      " Hosting Functional and LB meetings.",
      " Helping the teams to achieve targets on time.",
      " Creating timelines and tasks for the teams.",
      " Checking and maintaining the implemented dashboards, trackers and tools.",
      " Resolve team internal conflicts.",
      " Quick response to the OEVP.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " Performance of teams.",
      " Achieved number of targets.",
      " Process time of opportunities.",
      " Updated dashboard and trackers.",
      " Summary of LB meetings.",
    ],
    color: "#0A8EA0",
    application: {
      applicationLink: "https://forms.gle/UACxJGgfq1SqAeV7A",
      teamStructure: [
        "OxP Manager x1",
        "OppM Team Leader x1",
        "IRaM Team Leader x2",
      ],
    },
    function: {
      functionName: "iGT IR & M",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "OppM Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Keeping communication with B2B function.",
      " Updating the IR teams about the opportunities.",
      " Getting opportunity marketing materials on time.",
      " Maintaining the implemented trackers and tools.",
      " Delivering the recieved possible CVs to B2B function.",
      " Getting updates about the given CVs.",
      " Downscaling the knowledge to the members.",
      " Taking team meetings with the team members.",
      " Updating the Manager regarding the team performance.",
      " Quick response to the Manager.",
      " Taking responsibility for the team.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " Process time of tasks.",
      " Updated CV bank, Opportunity Search Tool.",
      " Updated MKT materials drive folder.",
      " Updated dashboard and trackers.",
      " Summary of CV feedbacks.",
    ],
    color: "#0A8EA0",
  },
  {
    id: 3,
    title: "IRaM Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Conducting IR researches and analysis.",
      " IR partner management.",
      " Assign members to reach out new and existing IR partners.",
      " Making sure a better connection is built between members and IR partners.",
      " Delivering IR partner standards.",
      " Delivering EP standards.",
      " Coordinating the recruitment and matching process.",
      " Maintaining the implemented trackers and tools.",
      " Updating the Manager regarding the team performance.",
      " Downscaling the knowledge to the team members.",
      " Taking team meetings with the team members.",
      " Quick response to the Manager.",
      " Taking responsibility for the team.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " Number of IR partners.",
      " Number of CVs.",
      " Number of approvals.",
      " Conversion ratio.",
      " Process Time.",
    ],
    color: "#0A8EA0",
  },
];

export const igt_b2b_vd = [
  {
    id: 1,
    title: "Performance Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Quick response to the OEVP.",
      " Beign flexible in the functional work and activities.",
      " Taking immediate actions on performance lacking and performance related issues.",
      " Managing the CRM process.",
      " Managing the market research process.",
      " Managing the overall performance measure in teams.",
      " Managing the key business partners in the CRM.",
      " Assist in making midterm to long term strategies with OEVP related to the Market Reseach and member perfromance.",
      " Downscaling functional knowledge.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # CRM addition.",
      " # rejection rates.",
      " Lead - Prospect - Partner -Realize.",
      " # new partners bring in",
      " # new initiatives bring in to the CRM process upgrades.",
    ],
    color: "#0A8EA0",
    application: {
      applicationLink: "https://forms.gle/xrhpnaRgidEe3FEo9",
      teamStructure: [
        "Performance Manager x2",
        "Operations Manager x3",
        "Team Leader x4",
      ],
    },
    function: {
      functionName: "iGT B2B & VD",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Operations Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Quick response to the OEVP.",
      " Beign flexible in the functional work and activities.",
      " Managing the key functional partners.",
      " Managing opportunity creation and maintain of the opportunities.",
      " Managing the EP handling process.",
      " Managing the value delivery process.",
      " Assist in making midterm to long term strategies with OEVP in related to eh EP handling and opportunity creation.",
      " Assist in the IR process.",
      " Downscaling functional knowledge.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # opportunities maintained.",
      " # partners  maintained.",
      " # EPs handled",
      " # new partners bring in.",
      " # new initiatives bring in to optimize the operations of iGT function.",
    ],
    color: "#0A8EA0",
  },
  {
    id: 3,
    title: "Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Team management.",
      " Hosting organizational meetings.",
      " Finalizing the market research.",
      " Downscaling the functional knowledge.",
      " Handling incoming EPs.",
      " Analytical and measuring team performance.",
      " Help in building corporate connections.",
      " Resolve team internal conflicts.",
      " Assist in the IR process.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # CRM additions.",
      " # rejection rates.",
      " # conversion rates.",
      "Lead - Prospect - Partner -Realize",
      " # new partners bring in.",
      " # EPs handled.",
      " # group meetups.",
    ],
    color: "#0A8EA0",
  },
];

export const fnl_im = [
  {
    id: 1,
    title: "Finance Manager - iGV",
    subFunction01: "Finance & Legal",
    subTitile01: "Job Description",
    jobDescription: [
      " Analyzing the current and past iGV financial practices of AIESEC in SLIIT.",
      " Overlook the finances of iGV projects through the iGV Project OCVP Finance & TLs.",
      " Constant reporting of the financial status of iGV projects to the OEVP F&L.",
      " Maintaining the financial data accuracy and Ensure the financial sustainability of iGV projects.",
      " Preparing financial performance reports of AIESEC in SLIIT iGV projects.",
      " Participate in Finance reviews.",
      " iGV Finance knowledge downscaling.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " %Budget variance in Projects.",
      " % of Sustainability of the Proect.",
      " #Report Created.",
    ],
    color: "#037EF3",
    application: {
      applicationLink: "https://forms.gle/zZ9A3pAxSDN4pDKh7",
      teamStructure: [
        "Finance Manager - iGV x1",
        "Finance Manager - Events x1",
        "IM Developer x1",
      ],
      subFunctions: {
        func1: "Finance & Legal",
        func2: "Information Management",
      },
    },
    function: {
      functionName: "Finance & Information Management",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Finance Manager - Events",
    subTitile01: "Job Description",
    jobDescription: [
      "Responsible for Overlook the finances of BD & EwA events through the Event OCVP Finance & OCPs.",
      "Constant reporting of the financial status of events to the OEVP F&L.",
      "Maintaining the financial data accuracy and Ensure the financial sustainability of events.",
      "Preparing financial performance reports of AIESEC in SLIIT Events.",
      "Participate in Finance reviews.",
      "Finance knowledge downscaling.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " % Budget variance in events.",
      " % of Sustainability of the event.",
      " # Report Created.",
    ],
    color: "#037EF3",
  },
  {
    id: 3,
    title: "IM Developer",
    subFunction02: "Information Management",
    subTitile01: "Job Description",
    jobDescription: [
      "Development and maintenance of tools, and dashboards to suit the requirements of AIESEC in SLIIT.",
      "Find the touchpoints to automate the current processes inside the entity.",
      "Organizing education projects/session for IM knowledge downscaling to the membership.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # tools developed",
      " # process that automated.",
      " # session and projects initiated.",
      " # IM education materials.",
    ],
    color: "#037EF3",
  },
];

export const dxp = [
  {
    id: 1,
    title: "Art Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Delegating the graphic arts and content writing work between relevant team leaders.",
      " Guiding and mentoring the graphic arts team and content writing team through team leaders.",
      " Handover contents to the relevant parties before the deadline.",
      " Maintaining good communication with the OEVP DXP and team leaders.",
      " Collaborate with the growth hacking manager while working for campaigns.",
      " Maintain the AIESEC brand tone and make sure final output is flawless.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of complaints.",
      " # of content delivered.",
      " # of MC submissions.",
    ],
    color: "#F48924",
    application: {
      applicationLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSc6HMygEyf2-vdhKHOonysHv9L5FN6J4v9Fq97VFEuKzVjsow/viewform?usp=pp_url",
      teamStructure: [
        "Art Manager x1",
        "Graphic Arts TL x1",
        "Lead Journalist x1",
        "Growth Hacking Lead x1",
        "Growth Hacking TL x2",
      ],
    },
    function: {
      functionName: "Digital Experience",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Graphic Arts Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Graphic Artists.",
      " Delegating the work between team members.",
      " Guiding and mentoring the team members.",
      " Collect and organize content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      " Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#F48924",
  },
  {
    id: 3,
    title: "Lead Journalist",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Content Writers.",
      " Edit and proofread written content.",
      " Guiding and mentoring the team members.",
      " Collect and organize written content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      " Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#F48924",
  },
  {
    id: 4,
    title: "Growth Hacking Lead",
    subTitile01: "Job Description",
    jobDescription: [
      " Working with OEVP DXP and functional coordinators to create marketing and content strategies for product related initiatives.",
      " Come Up with good strategies for product campaigns.",
      " Assign tasks to team leaders and follow-up on the progress.",
      " Handover contents to the relevant parties before the deadline.",
      " Reporting directly to the respective manager regarding tasks.",
      " Maintaining trackers and reporting directly to OEVP DXP.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of complaints.",
      " # of content delivered.",
      " # of MC submissions.",
      " # of reports.",
      " # of completed campaigns.",
    ],
    color: "#F48924",
  },
  {
    id: 5,
    title: "Growth Hacking Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      "Working with growth hacking lead and functional coordinators to provide product strategies",
      "Come Up with good strategies for product campaigns",
      "Assign tasks to team members and follow-up on the progress",
      "Handover contents to the growth hacking lead before the deadline",
      "Maintaining trackers and reporting directly to growth hacking lead",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints", " # of strategies created", " # of reports"],
    color: "#F48924",
  },
];

export const mkt = [
  {
    id: 1,
    title: "Art Director",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Graphic Designers.",
      " Manage the overall visual aspect of the graphic content.",
      " Delegating the work between team members.",
      " Guiding and mentoring the team members.",
      " Collect and organize content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      "  Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#F85A40",
    application: {
      applicationLink: "https://forms.gle/KQzAs4ZE5rKXD4oG6",
      teamStructure: [
        "Art Director x1",
        "Lead Journalist x1",
        "Video Producer x1",
        "Production Head x1",
        "R&D & Platforms Manager x1",
        "Showcasing Director x1",
      ],
    },
    function: {
      functionName: "Marketing",
      functionIntro: null,
    },
  },
  {
    id: 2,
    title: "Lead Journalist",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Content Writers & Content Presenters.",
      "  Manage the overall visual aspect of the video content.",
      " Edit and proofread written content.",
      " Delegating the work between team members.",
      " Guiding and mentoring the team members.",
      " Collect and organize written content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      " Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#F85A40",
  },
  {
    id: 3,
    title: "Video Producer",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Video Producers.",
      " Manage the overall visual aspect of the video content.",
      " Responsible for creating the video storyboard.",
      " Delegating the work between team members.",
      " Guiding and mentoring the team members.",
      " Collect and organize content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      " Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#CACCD1",
  },
  {
    id: 4,
    title: "Production Head",
    subTitile01: "Job Description",
    jobDescription: [
      " Responsible for managing the Art Director & Video Director.",
      " Manage the overall visual aspect of the video content & graphical content.",
      " Responsible for creating the video storyboard along with Video Director.",
      " Delegating the work between team members.",
      " Guiding and mentoring the team members.",
      " Collect and organize content created by team members to meet deadlines.",
      " Reporting directly to the respective manager regarding tasks.",
      " Collaborate with the other team leaders to ensure effective content marketing.",
      " Maintain the AIESEC brand tone.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of complaints.",
      " # of content delivered.",
      " # of strategies created.",
    ],
    color: "#F85A40",
  },
  {
    id: 5,
    title: "R&D & Platforms Manager",
    subTitile01: "Job Description",
    jobDescription: [
      " Working with OEVP Marketing and functional coordinators to create marketing and content strategies for non-product related initiatives.",
      " Manage content for PM and PD (Non-product related).",
      " Platforms handling.",
      " Assign tasks to team leaders and follow-up on the progress.",
      " Collect and organize content given by team leaders to meet deadlines.",
      " Maintaining trackers and reporting directly to OEVP Marketing.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of complaints.",
      " # of strategies created.",
      " # of MC submissions (Brand Promotions)",
      " # followers.",
      " # reach through followers",
    ],
    color: "#F85A40",
  },
  {
    id: 5,
    title: "Showcasing Director",
    subTitile01: "Job Description",
    jobDescription: [
      "Responsible for managing the Videographers and Photographers",
      "Responsible for planning of video content shooting of all the events assigned",
      "Responsible for multimedia and logistics handling of events",
      "Delegating the work between team members",
      "Guiding and mentoring the team members",
      "Collect and organize content created by team members to meet deadlines",
      "Reporting directly to the respective manager regarding tasks",
      "Collaborate with the other team leaders to ensure effective content marketing",
    ],
    subTitile02: "KPIs",
    KPIs: [" # of complaints.", " # of content delivered."],
    color: "#F85A40",
  },
];

export const pd = [
  {
    id: 1,
    title: "Sales Team Leader",
    subTitile01: "Job Description",
    jobDescription: [
      " Create long term Entity partnerships for the sustainability of the entity.",
      " Manage and communicate with partners regularly.",
      " Maintain and sell the AIESEC in SLIIT partnership portfolio.",
      " Maintain a close relationship with the Members.",
      " Proper management and execution of CRM.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of Leads.",
      " # of Proposals made.",
      " # of Partners Raised.",
      " Leads to Customer Conversion Ratio.",
    ],
    color: "#FFC845",
    application: {
      applicationLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSdmcAzOswMRu3X9xZCJJ01z4AvYeujldhVBF3NpgQD1jarFwQ/viewform",
      teamStructure: ["Sales Team Leaders x3"],
    },
    function: {
      functionName: "Partnership Development",
      functionIntro: null,
    },
  },
];

export const ewa_innovation = [
  {
    id: 1,
    title: "Team Leader - H4TF",
    subTitile01: "Job Description",
    jobDescription: [
      " Managing the Team Members.",
      " Keeping the OEVP updated regarding the progress.",
      " Being the bridge between OEVP and Team Members.",
      " Approach and Partner-up with companies providing opportunities for H4TF.",
      " Recruiting delegates for H4TF opportunities.",
      " Completing relevant tracking tools.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " # of opportunities available.",
      " # of delegate signups.",
      " Team Engagement.",
      " Team Performance.",
    ],
    color: "#0A8EA0",
    application: {
      applicationLink:
        "https://docs.google.com/forms/d/e/1FAIpQLSelJrbuehN-TQEMRCrhAQAcH3tTQWVkSlMyKTwiFu_Tkf1_JQ/viewform?vc=0&c=0&w=1&flr=0",
      teamStructure: ["Team Leader - H4TF x2", "Team Leader - Innovations x1"],
    },
    function: {
      functionName: "EwA & Innovation",
      functionIntro:
        "The Engage with AIESEC (EwA) phase exists to engage young people with the concept of leadership development and with our organization. Part of Engage with the AIESEC phase are all the activities and programs that aim to engage young people with the organization and with the concept of leadership development. These activities can be global or entity-level initiatives.",
    },
  },
  {
    id: 2,
    title: "Team Leader - Innovations",
    subTitile01: "Job Description",
    jobDescription: [
      " Managing the Team Members.",
      " Keeping the OEVP updated regarding the progress.",
      " Being the bridge between OEVP and Team Members.",
      " Supporting Innovation projects happening within the term.",
      " Designing PR focused events and making reports.",
      " Completing relevant tracking tools.",
    ],
    subTitile02: "KPIs",
    KPIs: [
      " Approval of Event design.",
      " Team Engagement.",
      " Team Performance",
    ],
    color: "#0A8EA0",
  },
];
